<template>
  <div>
    <div class="impersonationbar alert alert-danger mb-0" v-if="isImpersonated">
        {{ $t('navigation.logoutinas') }} {{ userFirstname }} {{ userLastname }} | {{ userEmail }}
        <button type="button" class="btn btn-sm" @click="unimpersonate()">{{ $t('navigation.logout') }}</button>
    </div>
    <div class="app-layout" :class="sidebarCollapsed ? 'collapsedSidebar' : ''">
      <the-sidebar />
      <section class="mainarea">
        <the-navbar />
        <main class="mainarea__content">
          <router-view></router-view>
        </main>
      </section>
    </div>
  </div>
</template>

<script>

import mixins from '../mixins'
import TheNavbar from '../components/Common/TheNavbar'
import TheSidebar from '../components/Common/TheSidebar'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'AppLayout',
  components: {
    TheNavbar,
    TheSidebar
  },

  computed: {
    ...mapGetters('common', [
      'sidebarCollapsed'
    ]),

    ...mapGetters('user', [
      'isImpersonated'
    ]),

    ...mapState('user', [
      'userLastname',
      'userFirstname',
      'userEmail'
    ])
  },

  mixins: [mixins],

  methods: {
    ...mapMutations('common', [
      'startLoading'
    ]),

    ...mapMutations('user', [
      'resetOriginalToken'
    ]),

    ...mapActions('user', [
      'getAccount'
    ]),

    unimpersonate: function () {
      this.resetOriginalToken()
      window.location.reload()
    }
  },

  mounted () {
    this.getAccount()
  }
}
</script>
